import { useSelector } from "react-redux";
import { AlertSidePanel } from "./Alerts.SidePanel";
import { LogsSidePanel } from "./Logs.SidePanel";

export { SidePanelLayout }

function SidePanelLayout() {

    const { type } = useSelector((state) => state.sidePanel);

    const SidePanelContent = () => {    
        switch (type) {
            case "diagLog":
                return <LogsSidePanel />;
            case "alert":
            default:
                return <AlertSidePanel />;
        }        
    };

    return (
        <SidePanelContent />
    );
}
